import BranchFundingSourceBaseController from '../common/branch_funding_source.base.controller'
import AppConstatnt from '../../../config/app.constants';

class BranchFundingSourceCreateController extends BranchFundingSourceBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, BranchFundingSourceService, Modal, $translate, LocationService, ShiptypeService, UserBranchService, BranchService,
		$q, $scope, TimezoneList, UsersService, CommonLayoutService, CurrencyService) {
		super(Auth, $state, User, BranchFundingSourceService, Modal, $translate, $scope)
		this.Auth = Auth
		this.$state = $state
		this.LocationService = LocationService;
		this.ShiptypeService = ShiptypeService;
		this.BranchService = BranchService;
		this.UserBranchService = UserBranchService;
		this.TimezoneList = TimezoneList;
		this.UsersService = UsersService;
		this.CommonLayoutService = CommonLayoutService;
		this.CurrencyService = CurrencyService;
		this.$q = $q;
		this.hasACL = {};
		this.businessDays = [{
			label: this.$translate.instant('location.mon'),
			model: 'businessDayMon'
		}, {
			label: this.$translate.instant('location.tues'),
			model: 'businessDayTue'
		}, {
			label: this.$translate.instant('location.wed'),
			model: 'businessDayWed'
		}, {
			label: this.$translate.instant('location.thurs'),
			model: 'businessDayThu'
		}, {
			label: this.$translate.instant('location.fri'),
			model: 'businessDayFri'
		}, {
			label: this.$translate.instant('location.sat'),
			model: 'businessDaySat'
		}, {
			label: this.$translate.instant('location.sun'),
			model: 'businessDaySun'
		}, {
			label: this.$translate.instant('location.hol'),
			model: 'businessDayHol'
		}];

		this.orderLeadDays = [{
			label: this.$translate.instant('branchFundingSource.one_business_day'),
			value: 1
		}, {
			label: this.$translate.instant('branchFundingSource.two_business_day'),
			value: 2
		}, {
			label: this.$translate.instant('branchFundingSource.three_business_day'),
			value: 3
		}, {
			label: this.$translate.instant('branchFundingSource.four_business_day'),
			value: 4
		}, {
			label: this.$translate.instant('branchFundingSource.five_business_day'),
			value: 5
		}];

		this.defaultModel = {
			// id: '',
			sourceName: '',
			branchId: User.getUser().branchId,
			shiptypeId: null,
			locationId: null,
			maxResidualDeposit: null,
			residualDeposit: true,
			manualDeposit: false,
			enableBankReport: false,
			bankReportFTPHost: '',
			bankReportFTPPort: 22,
			bankReportFTPUser: '',
			bankReportFTPPassword: '',
			bankReportFTPPrivateKey:'',
			key: "password",
			bankReportFTPDirectory: '',
			bankReportFilenameFormat: '',
			enableVaultReport: false,
			requireCountCommit: false,
			vaultReportRecipientName: '',
			vaultReportRecipientEmail: '',
			unpackAnyTime: false,
			editCountAnytime: false,
			deliveryReport: false,
			enforceBalanceCheckOnVaultClose: false,
			partialECDeposit: false,
			enableOrderMgmt: false,
			orderLeadTime: false,
			orderLeadDay: null,
			customerOrderLeadTime: false,
			orderLeadDays: null,
			orderLeadCutoff: null,
			depositProcessingTime: null,
			enforceStraps: false,
			orderInterest: false,
			loadedInterest: false,
			residualInterest: false,
			autoOrdering: true,
			autoOrderApproval: false,
			orderSequenceStart: null,
			orderApprovalThreshold: null,
			businessDayMon: false,
			businessDayTue: false,
			businessDayWed: false,
			businessDayThu: false,
			businessDayFri: false,
			businessDaySat: false,
			businessDaySun: false,
			businessDayHol: false,
			orderInterestPercentage: null,
			loadedInterestPercentage: null,
			residualInterestPercentage: null,
			networkData: false,
			autoReconcile: false,
			allowECLoad: false,
			orderCutoffTime: null,
			maxOrders: null,
			orderIdSequencing: false,
			regularInventoryId: null,
			emergencyInventoryId: null,
			editAmount: false,
			allowAmount: false,
			adHocDeposit: false,
			unifiedInventoryId: null, 
			bankReportType: 'NONE',
			multiDenomPack: true,
			multiDenomBillLimit: null,
			expectedResidual: false,
			timezone: null,
			pocEmail: '',
			atmForecasting: false,
			currencyId: 'USD',
			ecOrderLeadTime: null,
			varianceCheckEnabled: false,
			varianceThreshold: 0,
			denominations: [],
			autoCreateShipments: false,
			vaultReportFileType: '',
			bagoutForCount: false,
			inventoryBulkCoin: false,
			debitBulkCoinOnPack: false,
			contractedRate: null,
			averageBalanceFee: false,
			customerACH: false,
			customerACHOrderLeadDays: null,
			customerACHSettlementDays: null,
			bankOrder: false,
			bankOrderLeadDays: null,
			autoSendAccounting: false,
			autoSendAccountingTime: null,
			autoSendAccountingEmails: null,
			autoSendCustomerCount: false,
			autoSendCustomerCountTime: null,
			autoSendCustomerACH: false,
			autoSendCustomerACHTime: null,
		};
		
		this.locationList = [];
		this.shiptypeData = [];
		this.branch = [];
		this.loading = false;
		this.model = angular.copy(this.defaultModel);
		this.timezoneList = this.TimezoneList.getTimezoneList();
		this.loggedInUser = User.getUser().id;
		this.browserTimezone = moment.tz.guess();
		this.bankReportTypes = this.CommonLayoutService.bankReportTypes()
		this.vaultReportFileTypes = [
			{ label: 'Excel', value: 'excel' },
			{ label: 'PDF', value: 'pdf' }
		]
		this.emailValidation = true;
		this.intervalList = [
			{
				label: 'Dynamic',
				value: 'dynamic',
				day: 0
			},
			{
				label: 'Weekly',
				value: 'weekly',
				day: 7
			},
			{
				label: 'Bi-Weekly',
				value: 'Bi-weekly',
				day: 10
			},
			{
				label: 'First Day of Month',
				value: 'first-day-of-month',
				day: 30
			},
			{
				label: '2nd Weekly',
				value: '2nd-weekly',
				day: 14
			},
			{
				label: '3rd Weekly',
				value: '3rd-weekly',
				day: 21
			},
			{
				label: '4th Weekly',
				value: '4th-weekly',
				day: 28
			},
			{
				label: '5th Weekly',
				value: '5th-weekly',
				day: 35
			},
			{
				label: '6th Weekly',
				value: '6th-weekly',
				day: 42
			},
			{
				label: '7th Weekly',
				value: '7th-weekly',
				day: 49
			},
			{
				label: '8th Weekly',
				value: '8th-weekly',
				day: 56
			},
			{
				label: '9th Weekly',
				value: '9th-weekly',
				day: 63
			},
			{
				label: '10th Weekly',
				value: '10th-weekly',
				day: 70
			},
			{
				label: '11th Weekly',
				value: '11th-weekly',
				day: 77
			},
			{
				label: '12th Weekly',
				value: '12th-weekly',
				day: 84
			}
		];

		this.orderingProfileOptions = [];
	}

	// load all location
	loadLocations(searchKey, offset) {
		searchKey = searchKey || null;

		this.Service.fundingSourceLocation(null, searchKey, this.model.branchId, AppConstatnt.defaultPageLimit, offset)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalRecord = data.total;
					this.locationList = this.mappingLocationData(data.results);
				}
				else {
					const location = this.mappingLocationData(data.results);
					this.locationList = this.locationList.concat(location);
				}
			})
			.catch((err) => {
				this.errorMessage = err.data.message + '<br/>';
			})
	}

	mappingLocationData(location) {
		return location.map((loc) => {
			return {
				Key: loc.locationId + " | " + loc.locationName,
				Value: loc.locationId
			}
		});
	}


	// load all shiptype
	loadshiptype(searchKey, offset) {

		searchKey = searchKey || '';

		const shiptypeSearchObj = {
			queryJSON: {
				rules: [
					{
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							},
							{
								field: 'description',
								condition: 'like',
								data: '%' + searchKey + '%'
							}
							],
							operator: 'OR'
						}
					}
				],
				operator: 'AND'
			},
		}

		this.ShiptypeService.all(shiptypeSearchObj, offset, AppConstatnt.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalRecords = data.total;
					this.shiptypeList = this.mappingShiptypeData(data.results);
				}
				else {
					const shiptype = this.mappingShiptypeData(data.results);
					this.shiptypeList = this.shiptypeList.concat(shiptype);
				}
			})
	}

	mappingShiptypeData(shiptype) {
		return shiptype.map((shiptypes) => {
			return {
				Key: shiptypes.id + " | " + shiptypes.description,
				Value: shiptypes.id
			}
		});
	}

	$onInit() {
		this.$q.all([
			this.loadLocations('', 0),
			this.loadshiptype('', 0),
			this.UsersService.getUserFieldData(this.loggedInUser),
			this.CurrencyService.all(null, 0, 100),
			this.BranchService.getBranchSetup(this.model.branchId)
			// this.UserBranchService.getUserBranches(this.model.loggedInUser)
		])
			.then((data) => {
				this.userDetails = data[2];
				this.branchSetup = data[4];
				this.currencyData = data[3].results.filter((o)=> this.branchSetup.availableCurrencyIds && this.branchSetup.availableCurrencyIds.includes(o.id));
                this.model.currencyId = this.branchSetup.currencyId;
				// this.model.timezone = (this.userDetails && this.userDetails.timezone) ? this.userDetails.timezone : this.browserTimezone;
				// this.branch = data[2].results.map((b) => (b.branchId));
			})
			.catch((err) => {
				console.log(err);
			})
	}


	loadBranchLocations() {
		this.model.locationId = "";
		this.loadLocations();
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		// this.model.timezone = (this.userDetails && this.userDetails.timezone) ? this.userDetails.timezone : this.browserTimezone;
		this.orderProfileData = [];
		this.orderingProfileOptions = [];
		this.clearErrors();
	}

	submit(evt) {
		this.generateOrderProfile();
		this.loading = true;
        const bfsDenoms = Object.values(this.model.denominations).flat();
		const denominations = bfsDenoms.filter((d) => d.currencyId === this.model.currencyId).map(d => {
			return {
				denominationId: d.id,
				multiDenomAllowed: d.multiDenomAllowed,
				customerOrderable: d.customerOrderable || false,
				expectedResidualPercentage: this.expectedResidualValue(d),
				currencyId: d.currencyId,
				coinFlag: d.coinFlag
			}
		});

		let newData = {		// id: this.model.id,
			sourceName: this.model.sourceName,
			branchId: this.model.branchId,
			shiptypeId: this.model.shiptypeId.Value,
			locationId: this.model.locationId.Value,
			timezone: this.model.timezone,
			maxResidualDeposit: this.model.maxResidualDeposit ? this.model.maxResidualDeposit : null,
			orderInterestPercentage: this.model.orderInterestPercentage ? this.removePrecentageSign('orderInterestPercentage') : null,
			loadedInterestPercentage: this.model.loadedInterestPercentage ? this.removePrecentageSign('loadedInterestPercentage') : null,
			residualInterestPercentage: this.model.residualInterestPercentage ? this.removePrecentageSign('residualInterestPercentage') : null,
			currencyId: this.model.currencyId,
			varianceCheckEnabled: this.model.varianceCheckEnabled,
			contractedRate: this.model.averageBalanceFee ? this.model.contractedRate : null,
			averageBalanceFee: this.model.averageBalanceFee,
		}
		newData = _.pick(Object.assign(this.model, newData), Object.keys(this.defaultModel))
		this.businessDays.forEach((day) => { newData[day.model] = !!this.model[day.model]; });
		newData.orderCutoffTime = newData.orderCutoffTime ? moment(newData.orderCutoffTime).format('HH:mm:ss') : null;
		newData.orderLeadCutoff = newData.orderLeadCutoff ? moment(newData.orderLeadCutoff).format('HH:mm:ss') : null;
		newData.autoSendAccountingTime = newData.autoSendAccountingTime ? moment(newData.autoSendAccountingTime).format('HH:mm:ss') : null;
		newData.autoSendCustomerCountTime = newData.autoSendCustomerCountTime ? moment(newData.autoSendCustomerCountTime).format('HH:mm:ss') : null;
		newData.autoSendCustomerACHTime = newData.autoSendCustomerACHTime ? moment(newData.autoSendCustomerACHTime).format('HH:mm:ss') : null;
		newData.orderProfileData = this.orderProfileData;
		newData.userId = this.loggedInUser;
		newData.bankReportFTPPassword = this.model.key === 'password' && this.model.bankReportFTPPassword ? this.model.bankReportFTPPassword : null;
		newData.bankReportFTPPrivateKey = this.model.key === 'privateKey' && this.model.bankReportFTPPrivateKey ? this.model.bankReportFTPPrivateKey : null;
		newData.unifiedInventoryId = this.model.bankReportType === 'CASHCONNECT' && this.model.unifiedInventoryId ? this.model.unifiedInventoryId : null;
		newData.regularInventoryId = this.model.bankReportType === 'USBANK' && this.model.regularInventoryId ? this.model.regularInventoryId : null;
		newData.emergencyInventoryId = this.model.bankReportType === 'USBANK' && this.model.emergencyInventoryId ? this.model.emergencyInventoryId : null;
        newData.multiDenomBillLimit = this.model.multiDenomPack ? this.model.multiDenomBillLimit : null;
        newData.varianceThreshold = this.model.varianceCheckEnabled ? this.model.varianceThreshold : null;
		newData.inventoryBulkCoin = this.model.inventoryBulkCoin ? this.model.inventoryBulkCoin : false;
		newData.debitBulkCoinOnPack = this.model.debitBulkCoinOnPack ? this.model.debitBulkCoinOnPack : false;
		newData.allowAmount = this.model.allowAmount ? this.model.allowAmount : false;
		newData.adHocDeposit = this.model.adHocDeposit ? this.model.adHocDeposit : false;
		newData.denominations = denominations;
		
		this.Service.create(newData)
			.then((data) => {
				this.loading = false;
				this.askCreate()
					.then((createAnotherFundingSource) => {
						if (createAnotherFundingSource) this.loadLocations('', 0)
					})
			})
			.catch((err) => {
				this.loading = false;

				if (err && err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
				else {
					this.Modal.errorModal(err.data.message);
				}
			})
	}

	validateManualDeposit() {
		this.model.manualDeposit = !this.model.residualDeposit;
	}

	validateResidualDeposit() {
		this.model.residualDeposit = !this.model.manualDeposit;
	}

	resetDeposit() {
		if (this.model.manualDeposit) this.model.maxResidualDeposit = null;
	}

	resetBankReportData() {
		if (!this.model.enableBankReport) {
			this.model.bankReportFTPHost = null;
			this.model.bankReportFTPPort = 22;
			this.model.bankReportFTPUser = null;
			this.model.bankReportFTPPassword = null;
			this.model.bankReportFTPPrivateKey = null;
			this.model.bankReportFTPDirectory = null;
			this.model.bankReportFilenameFormat = null;
			this.model.regularInventoryId = null;
			this.model.emergencyInventoryId = null;
			this.model.unifiedInventoryId = null;
			this.model.bankReportType = 'NONE';
		}
		if (!this.model.enableVaultReport) {
			this.model.vaultReportRecipientName = null;
			this.model.vaultReportRecipientEmail = null;
			this.model.key = 'password';
		}
	}

	isDaySelected(day) {
		return this.model[day.model];
	}

	toggleDay(day) {
		this.model[day.model] = !this.model[day.model]
	}

	resetOrderMgmt() {
		if (!this.model.enableOrderMgmt) {

		};
	}

	resetAutoOrderingData() {
		if (!this.model.autoOrdering) {
			this.model.networkData = false;
			this.model.autoReconcile = false;
			this.model.allowECLoad = false;
			this.model.enforceStraps = false;
			this.model.orderLeadTime = false;
			this.model.orderLeadDay = null;
			this.model.depositProcessingTime = null;
			this.model.enforceStraps = false;
			this.model.orderInterest = false;
			this.model.loadedInterest = false;
			this.model.residualInterest = false;
			this.model.orderInterestPercentage = null;
			this.model.loadedInterestPercentage = null;
			this.model.residualInterestPercentage = null;
			this.model.orderCutoffTime = null;
			this.model.maxOrders = null;
			this.model.orderIdSequencing = false;
			this.model.autoOrderApproval = false;
			this.model.orderSequenceStart = null;
			this.model.orderApprovalThreshold = null;
			this.orderProfileData = [];
			this.orderingProfileOptions = [];
			this.model.timezone = null;
			this.model.ecOrderLeadTime = null;
		}
	}

	resetCustomerOrderLeadData() {
		if (!this.model.customerOrderLeadTime) {
			this.model.orderLeadDays = null;
			this.model.orderLeadCutoff = null;
		}
	}

	resetCustomerAchData() {
		if (!this.model.customerACH) {
			this.model.customerACHOrderLeadDays = null;
			this.model.customerACHSettlementDays = null;
		}
	}

	resetBankOrderData() {
		if (!this.model.bankOrder) {
			this.model.bankOrderLeadDays = null;
		}
	}

	resetAchSendAccountingData() {
		if (!this.model.autoSendAccounting) {
			this.model.autoSendAccountingTime = null;
			this.model.autoSendAccountingEmails = null;
		}
	}

	resetAutoSendCustCountData() {
		if (!this.model.autoSendCustomerCount) {
			this.model.autoSendCustomerCountTime = null;
		}
	}

	resetAutoSendCustACHData() {
		if (!this.model.autoSendCustomerACH) {
			this.model.autoSendCustomerACHTime = null;
		}
	}

	ngPercentage(key) {
		if (this.model[key] && this.model[key].length) {
			let str = this.model[key]
			return this.model[key] = str.endsWith('%') ? str : str + '%';
		}
	}

	removePrecentageSign(key) {
		if (this.model[key] && this.model[key].length) {
			let str = this.model[key] || '';
			return this.model[key] = str.endsWith('%') ? str.replace('%', '') : str;
		}
	}

	// addOrderProfile() {
	// 	this.orderingProfileOptions.push({
	// 		profileName: null,
	// 		addsOrSwaps: 0,
	// 		maxLoadDays: 7,
	// 		isEdit: true,
	// 		isValidProfile: false,
	// 		status: true,
	// 		intervalObj: {
	// 			interval: {
	// 				label: 'Weekly',
	// 				value: 'weekly',
	// 				day: 7
	// 			},
	// 			intervalOptions: this.intervalList
	// 		}
	// 	})
	// }

	validateOrderingProfileFormControl() {
		var disableButton = this.orderingProfileOptions.map((data) => {
			this.isValidFormControl = true;
			this.isValidFormControl = this.isValidFormControl && data.isValidProfile;
			return this.isValidFormControl;
		})
		if (disableButton.indexOf(false) >= 0 && this.orderingProfileOptions.length > 0) return false;
		else return true;
	}

	removeOrderingProfile(index) {
		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('common.confirm_delete_message') + '?',
			callback: (({
				modal,
				$scope
			}) => {
				this.orderingProfileOptions.splice(index, 1);
				modal.close();
			}),
			negative: (({
				modal,
			}) => {
				modal.close();
			}),
			type: 'danger'
		})
	}

	saveOrderingProfile(obj, event) {
		event.preventDefault();
		obj.isValidProfile = true;
	}

	setEditFlag(obj) {
		obj.isEdit = false;
	}

	editOrderingProfile(obj) {
		obj.isEdit = true;
		obj.isValidBillingRules = false;
	}

	setMTBWLValue(obj) {
		const selectedInterval = obj.intervalObj.interval;
		obj.maxLoadDays = selectedInterval['day'];
	}

	generateOrderProfile() {
		if (!this.orderingProfileOptions.length) return [];
		this.orderProfileData = [];

		this.orderingProfileOptions.forEach((obj) => {
			this.orderProfileData.push({
				profileName: obj.profileName,
				addsOrSwaps: obj.addsOrSwaps,
				maxLoadDays: obj.maxLoadDays,
				status: obj.status,
				intervalLabel: obj.intervalObj.interval.label,
				intervalValue: obj.intervalObj.interval.value
			})
		})
	}

	hasValidEmails(receiverMail) {
		if (!receiverMail) return false;
		const emails = receiverMail.split(',').map(email => email.trim());
	  
		const uniqueEmails = new Set();
		for (const email of emails) {
		  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
			return false; 
		  }
		  if (uniqueEmails.has(email)) {
			return false; 
		  }
		  uniqueEmails.add(email);
		}
	  
		return true;
	  };

	updateOrderProfileStatus(obj) {
		this.Modal.confirmSupervisor('update-order-profile-status', null, ({ modal, supId }) => {
			obj.status = !obj.status;
			modal.close();
		}, ({ modal }) => {
			modal.close();
			this.isLoading = false;
		});
	}

	branchFundingSourceDenominationsModal() {
		this.Modal.branchFundingSourceDenominations(this.model.denominations, ({ modal, denominations, $scope }) => {
			this.isLoading = true;
			setTimeout(() => {
				this.model.denominations = denominations;
				this.isLoading = false;
			}, 100);
			modal.close();
		}, ({ modal }) => {
			modal.close();
		}, this.model.currencyId);
	}
	onCurrencyChange() {
		this.model.denominations = {};
	}

	isMultiDenomAllowed(denom) {
		if (!denom.coinFlag) {
			return true;
		}
		if (denom.coinPackaging && ['INDIVIDUAL','ROLLED'].includes(denom.coinPackaging)) {
			return true;
		}
		return false;
	}

	toggleMultiDenom(obj) {
		if (this.isMultiDenomAllowed(obj)) {
			obj.multiDenomAllowed = !obj.multiDenomAllowed;
		}
	}

	isExpectedResidualDenom(denom) {
		return !denom.coinFlag && !denom.unfit;
	}

	expectedResidualValue(denom) {
		if (!this.model.expectedResidual || !this.isExpectedResidualDenom(denom)) return null;
		const value = denom.expectedResidualPercentage;
		if (value === null || value === undefined || value === '') return null;
		return Number(String(value).replace('%', ''));
	}

	addResidualPercentSign(denom) {
		const value = denom.expectedResidualPercentage;
		if (value !== null && value !== undefined && String(value) !== '' && !String(value).endsWith('%')) {
			denom.expectedResidualPercentage = value + '%';
		}
	}

	removeResidualPercentSign(denom) {
		const value = denom.expectedResidualPercentage;
		if (value && String(value).endsWith('%')) {
			denom.expectedResidualPercentage = String(value).replace('%', '');
		}
	}

	toggleCustomerOrderable(obj) {
		obj.customerOrderable = !obj.customerOrderable;
	}

	validateMultiDenom(obj) {
		setTimeout(() => {
			if (!obj.isDenomSelected) {
				obj.multiDenomAllowed = false;
			} else {
				if (!this.isMultiDenomAllowed(obj)) {
					obj.multiDenomAllowed = false;
				}
			}
			this.$scope.$apply();
		});
	}

	removeDenomination(key, index) {
		this.model.denominations[key].splice(index, 1);
	}
}

export default BranchFundingSourceCreateController;



// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/create/branch_funding_source.create.controller.js